import { render, staticRenderFns } from "./m-refuse-history-modal.vue?vue&type=template&id=66a071f3&"
import script from "./m-refuse-history-modal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-refuse-history-modal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports